import { handleAssetUrl } from "../../utils";

export function FklHeader({ headerTitle }: { headerTitle: string }) {
  return (
    <div className="fkl-header">
      <img
        className="fkl-header--logo"
        src={handleAssetUrl("fkl-heart-rainbow.svg")}
        alt="rainbow heart"
      />
      <span
        className="fkl-header--title"
        dangerouslySetInnerHTML={{ __html: headerTitle }}
      />
    </div>
  );
}
